export const top = () => {
  window.scrollTo(0, 0);
};